import { render, staticRenderFns } from "./AttachmentConfigurator.vue?vue&type=template&id=66910fbc&"
import script from "./AttachmentConfigurator.vue?vue&type=script&lang=js&"
export * from "./AttachmentConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports